import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';
import { docentesApi } from '../docentes/DocentesService';
import { NOTAS_EVALUATIVAS_CONST } from '../notas/notas_evaluativas/NotasEvaluativasService';

export const ESTUDIANTES_CONST = 'estudiantes';
export const estudiantesApi = `${baseUrl}/${ESTUDIANTES_CONST}`;

export const allEstudiantesService = async (params) => {
  const res = await axios.get(estudiantesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const oneEstudiantesService = async (id) => {
  const res = await axios.get(`${estudiantesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const notasEvaluativasEstudianteService = async (id, params) => {
  const res = await axios.get(`${estudiantesApi}/${id}/notas-evaluativas`, {
    headers: token({}),
    params,
  });
  return res;
};

export const asistenciasDiariasEstudianteService = async (id, params) => {
  const res = await axios.get(`${estudiantesApi}/${id}/asistencias-diarias`, {
    headers: token({}),
    params,
  });
  return res;
};

export const allEstudiantesDocenteService = async (idDocente, params) => {
  const res = await axios.get(
    `${docentesApi}/${idDocente}/${ESTUDIANTES_CONST}/all`,
    {
      headers: token({}),
      params,
    },
  );
  return res;
};

export const allEstudiantesDocenteAdminService = async (idDocente, params) => {
  const res = await axios.get(
    `${docentesApi}/${idDocente}/${ESTUDIANTES_CONST}`,
    {
      headers: token({}),
      params,
    },
  );
  return res;
};

export const allEstudiantesNotasEvaluativasService = async (params) => {
  const res = await axios.get(`${estudiantesApi}/${NOTAS_EVALUATIVAS_CONST}`, {
    headers: token({}),
    params,
  });

  return res;
};

export const updateEstatusEstudianteService = async (data) => {
  const res = await axios.post(`${estudiantesApi}/update-estatus`, data, {
    headers: token({}),
  });
  return res;
};

export const asignarSeccionsEstudianteService = async (data) => {
  const res = await axios.post(`${estudiantesApi}/asignar-seccion`, data, {
    headers: token({}),
  });
  return res;
};
